import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';

import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';
import { ShardsRoutingModule } from './shards.routing';

import { SCWShardsComponent } from './shards.component';
import { SCWShardsItemModule } from './item';
import { SCWShardsItemXModule } from './item-x/module';

import { ShardsResolver } from './shards.resolver';

@NgModule({
    imports: [
        CommonModule,

        MatSliderModule,

        CoreModule,
        SharedModule,
        UIModule,

        ShardsRoutingModule,
        SCWShardsItemModule,
        SCWShardsItemXModule,
    ],
    declarations: [
        SCWShardsComponent,
    ],
    entryComponents: [
        SCWShardsComponent,
    ],
    providers: [
        { provide: APP_BASE_HREF, useValue : '!/shards2' },
        ShardsResolver
    ]
})
export class ShardsModule { }
